<template>
  <v-tabs v-model="activeGeneralTab" class="white" style="min-height:550px;">
    <v-tab v-for="(tab, ind) in tabs" :key="ind" ripple>{{ tab.text }}</v-tab>
    <v-tab-item :key="0">
      <FinancialConfig />
    </v-tab-item>
    <v-tab-item :key="1">
      <FinancialRegister />
    </v-tab-item>
    <!-- <v-tab-item :key="2">
      <FinancialUpload />
    </v-tab-item>-->
  </v-tabs>
</template>

<script>
import FinancialConfig from '@/components/financial/financialConfig/FinancialConfig'
import FinancialRegister from '@/components/financial/financialRegister/FinancialRegister'
// import FinancialUpload from "./financialUpload/FinancialUpload";

export default {
  name: 'Financial',

  components: {
    FinancialConfig,
    FinancialRegister
    // FinancialUpload
  },

  data () {
    return {
      tabs: [
        { name: 'config', text: 'Configuração' },
        { name: 'register', text: 'Cadastro de contas' }
        // { name: "financialUpload", text: "Enviar arquivos finaceiros" }
      ],
      activeGeneralTab: null
    }
  },

  methods: {
    initialize (user) {
      let dataSearch = {}
      if (user && user.name) {
        dataSearch.params = {
          ...user
        }
      }
      let obj = {
        url: '/api/user',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        response.data = response.data.map(line => {
          line.hover = false
          return line
        })
        this.tableData = response.data
      })
    }
  }
}
</script>

<style>
.miniTab .v-tabs__container {
  height: auto !important;
  margin: 1px;
}
.miniTab .v-tabs__item--active {
  background-color: #cfd8dc !important;
}
</style>
